import { aiBacking } from "./aiBacking";
import type { AgentAnswers } from "./reviewRow.types";
import {
  decisionSentence,
  type PickedField,
  type SentenceRow,
} from "./decisionSentence";
import { stepMarks } from "./stepMarks";

export type StepNoteData = { title: string; body: string };

type Args = {
  row: SentenceRow & { agent?: unknown };
  readOnly: boolean;
  pick: PickedField;
  pickedLeaf: string | null;
  noField: boolean;
  needLook: number;
  sameLeafLabel?: string;
  lead: string | null;
  lostWords: string;
  kindHint: string | null;
  valuesUnmapped: boolean;
};

export function stepOne(a: Args) {
  const agent = a.row.agent as AgentAnswers | null;
  const notes: StepNoteData[] = [];
  if (!a.readOnly) {
    if (agent && !agent.agreed && !a.pick.path && !a.noField)
      notes.push({
        title: "The two AIs picked different fields.",
        body: "Pick one card below.",
      });
    if (a.kindHint) notes.push({ title: "Check the kind.", body: a.kindHint });
  }
  const sentence = (n: number) =>
    decisionSentence(
      a.row,
      a.pickedLeaf,
      n,
      a.sameLeafLabel,
      a.lead,
      a.lostWords,
      a.pick,
    );
  const { text, tone: weak } = a.noField
    ? { text: `You picked ${a.pick.label}.`, tone: "good" as const }
    : sentence(0);
  const hasPick = Boolean(a.pickedLeaf || a.pick.path || a.noField);
  const backing = aiBacking(agent, a.pick.path);
  const marks = stepMarks({
    readOnly: a.readOnly,
    hasPick,
    fieldNotes: notes.length + (hasPick && weak !== "good" ? 1 : 0),
    valuesToCheck: a.needLook,
    valuesUnmapped: a.valuesUnmapped,
    aiAgree: backing === null ? null : backing === "all",
  });
  const tag = a.readOnly
    ? "Saved"
    : !hasPick
      ? "Needs a pick"
      : marks[0] === "done"
        ? "Strong match"
        : backing === "one" || backing === "none"
          ? "Check the pick"
          : a.kindHint
            ? "Check the kind"
            : "Needs a look";
  return { notes, proof: text, tag, marks };
}
